//Libs
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faFileExcel, faTimes } from "@fortawesome/free-solid-svg-icons";
//Hooks
import { useFetchWithFile } from "../../Hooks/useFetchWithFile";
//Config
import { API_URL } from "../../config/env";
//Components
import DragAndDropFileUpload from "../Common/DragAndDropFileUpload";
import Loading from "../Common/Loading";
//Style
import './Style/InvoiceComparison.css';
import { useNavigate } from "react-router-dom";

//Operadores logísticos suportados pelo back-end (warehouseId define o layout da planilha de fatura)
const warehouses = [
    { id: 1, name: 'Serra Park' },
    { id: 2, name: 'Bramarlog' },
];

export const InvoiceComparison = () => {
    const [warehouseId, setWarehouseId] = useState<number | null>(null);

    const {
        file,
        downloadUrl,
        isLoading,
        error,
        handleUpload,
        handleFileChange,
        handleFileRemove,
        handleResetStatus
    } = useFetchWithFile(
        `${API_URL}/confrontofatura`,
        warehouseId !== null ? { warehouseId } : undefined
    );

    const navigate = useNavigate();

    return (
        <div className="container">
            {downloadUrl === undefined && !isLoading && 
                <form className="form" id="invoiceComparison" method='post' onSubmit={handleUpload}>
                    <header className="form-header">
                        <FontAwesomeIcon icon={faArrowLeft} onClick={()=>navigate(-1)}/>
                        <h4 className="title">Confronto de Fatura</h4>
                        <p className="subtitle">Realize o upload da planilha de fatura para que <br/> o sistema faça a comparação com os dados do ERP</p>
                    </header>
                    <fieldset className="warehouse-select">
                        <legend>Operador logístico</legend>
                        {warehouses.map((warehouse) => (
                            <label key={warehouse.id} htmlFor={`warehouse-${warehouse.id}`}>
                                <input
                                    type="radio"
                                    name="warehouse"
                                    id={`warehouse-${warehouse.id}`}
                                    value={warehouse.id}
                                    checked={warehouseId === warehouse.id}
                                    onChange={() => setWarehouseId(warehouse.id)}
                                />
                                {warehouse.name}
                            </label>
                        ))}
                    </fieldset>
                    <div>
                        <DragAndDropFileUpload onFileUpload={handleFileChange}/>
                        {file && (
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                <li style={{ display: "flex", alignItems: "center", gap: "10px", margin: "5px 0" }}>
                                    <FontAwesomeIcon icon={faFileExcel} style={{ color: "#63E6BE" }} />
                                    <span>{file.name} ({(file.size / 1024).toFixed(2)} KB)</span>
                                    <button
                                    type="button"
                                    style={{ background: "transparent", border: "none", cursor: "pointer", color: "red" }}
                                    onClick={handleFileRemove}
                                    >
                                    <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                    <div className="action">
                        <button className="btn success" type="submit" disabled={isLoading || !file || warehouseId === null}>
                            {isLoading ? 'Enviando...' : 'Enviar'}
                        </button>
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </form>
            }
            {isLoading && 
                <Loading loadingMessage="Processando dados..."/>
            }
            {downloadUrl &&
                <div className="card-wrapper">
                    <div className="content">
                        <button type="button" className="btn-flex btn-link" onClick={handleResetStatus}>
                            <FontAwesomeIcon icon={faArrowLeft}/>
                            Voltar
                        </button>                    
                        <FontAwesomeIcon icon={faFileExcel} size="8x" style={{color: "#0c6d50",}} />
                        <p>Análise dos dados concluída com sucesso! <br/> Clique em baixar para conferir os resultados.</p>
                        <div className="action">
                            <a type="button" className="btn success shadow" href={downloadUrl}>Baixar</a>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
